import api from '..';

export const postJoinWaitlistRequest = (payload) => {
  return api.post('/day1x-subscribe', payload);
};
